import type { DeepPartial } from '@luna/utils-ts';

import type { Overview } from '../../types/Overview';

export const overviewATFeatureConfig: DeepPartial<Overview> = {
    applyPositionsForTitleCount: true,
    getSumPerTypeMarketValue: true,
    showOnlyLengthOfVisibleModels: true,
    sumValueFromMarketValue: true,
    sumValueFromPerformance: true,
    totalMarketValueFromOtherTitleModels: true,
    showFilterSubAccount: true,
};
